<template>
	<div>
		<b-modal
			id="deleteTest"
			v-model="deleteModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			@hide="$emit('hide')"
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution
				<img src="../../../assets/deletepopupicon.svg" alt="" />
			</div>
			<div @click="closedeletemodal()" class="xMarkCancel pointer">
				<img src="../../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 text-break caution-modal-text">
				<span>Are you sure you want to delete "{{ testDetails.name }}" ?</span>
			</div>
			<div class="normaltext">
				<span class="asterik">*</span
				><span>Please note this action cannot be undone</span>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button class="addbtn" @click="deleteTest()">Delete</b-button>
			</div>
		</b-modal>
	</div>
</template>

<script>
import { deleteTest } from "../../../utils/apiFunctions.js";
export default {
	name: "DeleteTest",
	// mixins: [successToast],

	// Props allow parent components to pass data to this component
	props: {
		// Indicates whether the delete modal is shown or not
		deleteModal: Boolean,

		// Details of the test to be deleted
		testDetails: Object,

		// The ID of the topic to which the test belongs
		topicID: String,

		context: Object,
	},
	created() {
		// Add a global event listener for keyup
		window.addEventListener("keyup", this.handleKeyUp);
	},

	beforeDestroy() {
		// Lifecycle hook: Component is about to be destroyed
		// Remove the global event listener when the component is destroyed
		window.removeEventListener("keyup", this.handleKeyUp);
	},

	methods: {
		// Method to delete a test
		async deleteTest() {
			try {
				// Prepare payload for API request
				let payload = {
					topicID: this.topicID,
					testID: this.testDetails.testID,
				};

				// Send request to delete the test
				const response = await deleteTest(payload);

				// Check if the response is successful
				if (response.status === 200) {
					// Show success toast
					this.$emit("resetPagination");

					this.$store.commit("testVUEX/saveshowPreviewTest", {
						preview_status: false,
					});
					// Emit an event to reset pagination
					setTimeout(() => {
						this.context.successToast("Test deleted successfully!");
					}, 200);
					// Hide the deleteTest modal
					this.$bvModal.hide("deleteTest");
				} else if (response.status === 409) {
					this.context.errorToast("Test is tagged to a job and cannot be deleted.");
				}
			} catch (error) {
				// Handle errors
				console.log(error);
			}
		},

		// Method to close the delete modal
		closedeletemodal() {
			this.$bvModal.hide("deleteTest");
			// Emit an event to notify parent component about modal closure
			this.$emit("cardClose");
		},

		// Event handler for keyup event
		handleKeyUp(event) {
			if (event.keyCode === 13) {
				// If Enter key is pressed, call deleteTest method
				this.deleteTest();
			}
		},
	},
};
</script>
